<script setup lang="ts">
import { type Game, useGameStore } from "@/stores/games.ts";
import TeamDisplay from "@/components/TeamDisplay.vue";
const gameStore = useGameStore();

const props = defineProps<{
  game: Game;
}>();
</script>

<template>
<div class="row">
  <div>
    <span class="game-number">#{{ gameStore.games.indexOf(props.game) + 1 }}</span>
  </div>
  <div class="game-date-container">
    <span class="game-date">{{ new Date(props.game.dateTime).toLocaleTimeString('de-DE', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }) }}</span>
  </div>
  <div>
    <TeamDisplay
      :team="props.game.teams.home"
      class="table-item-team"
    />
  </div>
  <div>
    <TeamDisplay
      :team="props.game.teams.away"
      class="table-item-team"
    />
  </div>
  <div class="mobile-row">
    <div class="score-display">
      <span>{{ props.game.score ? props.game.score.home : '-' }}</span>
      <span>:</span>
      <span>{{ props.game.score ? props.game.score.away : '-' }}</span>
    </div>
  </div>
</div>
</template>

<style scoped>
.row {
  display: grid;
  grid-template-columns: 1fr 2fr 4fr 4fr 2fr;
}

.score-display {
  display: grid;
  grid-template-columns: 1fr 1rem 1fr;
  align-items: center;
  justify-content: center;
  text-align: center;

  :first-child {
    text-align: right;
  }
  :last-child {
    text-align: left;
  }
}

@media (max-width: 600px) {
  .row {
    border-radius: 0.5rem;
    padding: 0 0.5rem;
    background-color: var(--color-layer-2);

    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto auto;

    .mobile-row {
      text-align: center;
      grid-column: 1 / -1;
    }

    .score-display {
      font-size: 2rem;
    }

    .game-date-container {
      text-align: end;
    }
  }
}
</style>

<style>
@media (max-width: 600px) {
  .table-item-team {
    flex-direction: column;
    text-align: center;

    .team-logo {
      width: 3rem;
      height: 3rem;
    }
  }
}
</style>
